export const report = {
  /**
   * Gets the programmatic name of the entire locale, with the language,
   *	country and variant separated by underbars. The Language is always lower case,
   *	and country is always upper case. If the language is missing,
   *	the string will begin with an underscore character.
   *	If both the language and country fields are missing,
   *	this function will return the empty string,
   *	even if the variant field is filled in (you cannot have a locale with just a variant--
   *	the variant must accompany a valid language or country code). Examples: "en"
   *
   */
  en: {
    device_installation_reports: "Summary Reports",
    device_installation_success_detailed_reports: "Success Detailed Reports",
    device_onboard_success_detailed_reports: "Device Onboard Preview",
    device_installation_failure_detailed_reports: "Failure Detailed Reports",
    successfully_installed_devices: "Successfully Installed Devices",
    failed_installation_devices: "Failed Installation Devices",
    field_engineer_mobile: "Field Engineer Mobile #",
    field_engineer: "Field Engineer",
    product_code: "Product Code",
    product_type: "Product Type",
    project_name: "Project Name",
    customer_name: "Customer Name",
    device_id: "Device Id",
    network_parameters:
      "Network Parameters (+) Symbol -- If we expand this, the next columns will be highlighted.",
    serial_number: "Serial Number",
    pole: "Pole #",
	  testStatus: "Test Status",
    testTime: "Test Time",
    locationCategory:"Location Category",
    lampbrandname:"Lamp Brand Name",
    category:"Category",
    maxpowerconsumption:"Max power Consumption",
    minpowerconsumption:"Min Power Consumption",
    ledModelNumber:"Led Model Number",
    poleModelNumber:"Pole Model Number",
    deviceModelNumber:"Device Model Number",
    LED_model: "LED Model #",
    lamp_sub_level: "Lamp Sub Level #",
    device_lat_long: "Device Lat/Long",
    installated_locations: "Installated Locations",
    installation_date_time: "Installation Date & Time",
    failure_reason: "Failure Reason",
    snaps: "Snaps",
    SNR_uplink_test_1: "SNR - Uplink (Test 1)",
    SNR_downlink_test_2: "SNR - Downlink (Test 2)",
    RSSI_uplink_test_1: "RSSI - Uplink (Test 1)",
    RSSI_downlink_test_2: "RSSI - Downlink (Test 2)",
    SF_uplink_test_1: "SF - Uplink (Test 1)",
    SF_downlink_test_2: "SF - Downlink (Test 2)",
    Fcount_uplink_test_1: "Fcount - Uplink (Test 1)",
    Fcount_downlink_test_2: "Fcount - Downlink (Test 2)",
    property_id: "Property Id",
    property_type: "Property Type",
    consumer_name: "Consumer Name",
    total_consumers: "Total Consumer's",
    consumer_id: "Consumer ID",
    consumer_mobile: "Consumer Mobile",
    consumer_mail_id: "Consumer Mail Id",
    flat_no: "Flat No",
    tower: "Tower",
    area: "Area",
    drs_level: "DRS Level",
    zone: "Zone",
    device_ui: "Device UI",
    occupant_mobile: "Occupant Mobile",
    tower_name: "Tower Name",
    owner_name: "Owner Name",
    amr_device_id: "AMR Device Id",
    alert_type: "Alert Type",
    alert_description: "Alert Description",
    received_date_and_time: "Received Date & Time",
    owner_email_id: "Owner Email Id",
    owner_mobile_number: "Owner Mobile Number",
    address: "Address",
    consumer_consumption: "Consumer Consumption",
    total_consumption: "Total Consumption",
    drs_level_consumption: "DRS Level Consumption",
    tampering: "Tampering",
    meter_health: "Meter Health",
    pincode: "Pin Code",
    meter_health_status: "Meter Health Status",
    date_and_time: "Date & Time",
    opening_reading: "Opening Reading",
    closing_reading: "Closing Reading",
    feederName: "Feeder Name",
    feederMobileNo: "Feeder Mobile Number",
    feederLatLong: "Feeder Lat Long",
    status: "status",
    failureReason: "Failure Reason",
    installationDate: "Installation Date",
    action: "Action",
    export:"Export",
    back:"Back",
    onboardingStatus: "Onboarding Status",
    report_Success_Device_Installation:"reportSuccessDeviceInstallation",
    report_Device_Installation:"reportDeviceInstallation",
    report_Failure_Device_Installation:"reportFailureDeviceInstallation",
    devices:"devices",
    onboard:"OnBoard",
    submit:"Submit",
    excel_error_record:"Export excel with error records",
    device_serial_no:"Device Serial No",
    is_firmware_updated: "Firmware Update Status",
    new_firmware_version:"Updated Firmware Version",
    old_firmware_version:"Previous Firmware Verion",
    done_by:"Done by",
    updated_Date_time:"Date & Time",
    report_firmware_updation: "reportFirmwareUpdation",
    firmwareVersion:"Firmware Version"
  },

  ar: {
    device_installation_reports: "تقارير موجزة",
    device_installation_success_detailed_reports: "تقارير مفصلة عن النجاح",
    device_installation_failure_detailed_reports: "تقارير مفصلة الفشل",
    device_onboard_success_detailed_reports: "معاينة الجهاز على متن الطائرة",
    successfully_installed_devices: "الأجهزة المثبتة بنجاح",
    failed_installation_devices: "أجهزة التثبيت الفاشلة",
    field_engineer_mobile: "رقم الجوال للمهندس الميداني",
    field_engineer: "مهندس ميداني",
    product_code: "كود المنتج",
    product_type: "نوع المنتج",
    project_name: "اسم المشروع",
    customer_name: "اسم الزبون",
    device_id: "معرف الجهاز",
    network_parameters:
      "معلمات الشبكة (+) رمز - إذا قمنا بتوسيع هذا ، فسيتم تمييز الأعمدة التالية.",
    serial_number: "رقم سري",
    pole: "عمود #",
	  testStatus: "حالة الاختبار",
    testTime: "وقت الاختبار",
    locationCategory:"فئة الموقع",
    lampbrandname:"اسم العلامة التجارية للمصباح",
    category:"فئة",
    maxpowerconsumption:"أقصى استهلاك للطاقة",
    minpowerconsumption:"الحد الأدنى من استهلاك الطاقة",
    ledModelNumber:"رقم موديل الصمام",
    poleModelNumber:"رقم موديل القطب",
    deviceModelNumber:"رقم طراز الجهاز",
    LED_model: "نموذج LED #",
    lamp_sub_level: "المستوى الفرعي للمصباح #",
    device_lat_long: "جهاز Lat / Long",
    installated_locations: "المواقع المثبتة",
    installation_date_time: "تاريخ ووقت التثبيت",
    failure_reason: "سبب الفشل",
    snaps: "استقرار",
    SNR_uplink_test_1: "SNR - الإرسال (اختبار 1)",
    SNR_downlink_test_2: "SNR - الهابطة (اختبار 2)",
    RSSI_uplink_test_1: "RSSI - الإرسال (اختبار 1)",
    RSSI_downlink_test_2: "RSSI - الهابطة (اختبار 2)",
    SF_uplink_test_1: "SF - الإرسال (اختبار 1)",
    SF_downlink_test_2: "SF - الهابطة (اختبار 2)",
    Fcount_uplink_test_1: "Fcount - الإرسال (اختبار 1)",
    Fcount_downlink_test_2: "Fcount - الهابطة (اختبار 2)",
    property_id: "معرف الخاصية",
    property_type: "نوع الملكية",
    consumer_name: "اسم المستهلك",
    total_consumers: "إجمالي المستهلكين",
    consumer_id: "معرف المستهلك",
    consumer_mobile: "المستهلك المحمول",
    consumer_mail_id: "معرف بريد المستهلك",
    flat_no: "رقم الشقة",
    tower: "المنطقة",
    area: "منطقة",
    drs_level: "مستوى DRS",
    zone: "المنطقة",
    device_ui: "واجهة مستخدم الجهاز",
    occupant_mobile: "الهاتف المحمول للساكن",
    tower_name: "اسم البرج",
    owner_name: "اسم المالك",
    amr_device_id: "معرّف جهاز AMR",
    alert_type: "نوع منبه",
    alert_description: "وصف التنبيه",
    received_date_and_time: "تاريخ ووقت الاستلام",
    owner_email_id: "معرف البريد الإلكتروني للمالك",
    owner_mobile_number: "رقم هاتف المالك",
    address: "عنوان",
    consumer_consumption: "استهلاك المستهلك",
    total_consumption: "إجمالي الاستهلاك",
    drs_level_consumption: "استهلاك مستوى DRS",
    tampering: "العبث",
    meter_health: "صحة العدادات",
    pincode: "الرقم السري",
    meter_health_status: "الحالة الصحية للعداد",
    date_and_time: "التاريخ والوقت",
    opening_reading: "فتح القراءة",
    closing_reading: "القراءة الختامية",
    feederName: "اسم المغذي",
    feederMobileNo: "رقم الهاتف المحمول للمغذي",
    feederLatLong: "جهاز التغذية Lat Long",
    status: "الحالة",
    failureReason: "سبب الفشل",
    installationDate: "تاريخ التثبيت",
    action: "الوظيفة",
    export:"يصدر",
    back:"الى الخلف",
    report_Success_Device_Installation:"الإبلاغ عن تثبيت جهاز ناجح",
    report_Device_Installation:"الإبلاغ عن تثبيت جهاز ناجح",
    report_Failure_Device_Installation:"تقرير فشل الجهاز التثبيت",
    devices:"جهاز",
    onboard:"صعد على متنها",
    report_Success_Device_Installation:"تقرير نجاح تثبيت الجهاز",
    onboardingStatus: "حالة على متن الطائرة",
    submit:"إرسال",
    excel_error_record:"اكسل تصدير مع سجلات الخطأ",
    device_serial_no: "الرقم التسلسلي للجهاز",
    is_firmware_updated: "حالة تحديث البرنامج الثابت",
    new_firmware_version: "إصدار البرنامج الثابت المحدث",
    old_firmware_version: "إصدار البرنامج الثابت السابق",
    done_by: "تم بواسطة",
    updated_Date_time: "التاريخ والوقت",
    report_firmware_updation: "تقرير تحديث البرنامج الثابت",
    firmwareVersion: "إصدار البرنامج الثابت"
  }
};
